/**
 * "Widget" documentation section (ADR-0074).
 * The embeddable chat widget. This file starts with embedding/config/runtime/
 * theming; the end-user experience pages (surfaces, chat, headless, a11y) follow.
 */
import { WIDGET_A11Y_PAGE } from './pages/widget-accessibility.page';
import { WIDGET_API_PAGE } from './pages/widget-api.page';
import { WIDGET_CHAT_PAGE } from './pages/widget-chat.page';
import { WIDGET_CONFIG_PAGE } from './pages/widget-config.page';
import { WIDGET_CUSTOM_CSS_PAGE } from './pages/widget-custom-css.page';
import { WIDGET_CUSTOM_UI_PAGE } from './pages/widget-custom-ui.page';
import { WIDGET_EMBEDDING_PAGE } from './pages/widget-embedding.page';
import { WIDGET_EXTENDING_PAGE } from './pages/widget-extending.page';
import { WIDGET_MOBILE_WEBVIEW_PAGE } from './pages/widget-mobile-webview.page';
import { WIDGET_OVERVIEW_PAGE } from './pages/widget-overview.page';
import { WIDGET_SURFACES_PAGE } from './pages/widget-surfaces.page';
import { WIDGET_THEMING_PAGE } from './pages/widget-theming.page';

import type { DocSection } from './types';

export const WIDGET_SECTION: DocSection = {
  id: 'widget',
  titleKey: 'docs.section.widget.title',
  pages: [
    WIDGET_OVERVIEW_PAGE,
    WIDGET_EMBEDDING_PAGE,
    WIDGET_MOBILE_WEBVIEW_PAGE,
    WIDGET_CONFIG_PAGE,
    WIDGET_API_PAGE,
    WIDGET_EXTENDING_PAGE,
    WIDGET_THEMING_PAGE,
    WIDGET_CUSTOM_CSS_PAGE,
    WIDGET_SURFACES_PAGE,
    WIDGET_CHAT_PAGE,
    WIDGET_CUSTOM_UI_PAGE,
    WIDGET_A11Y_PAGE,
  ],
};
